import BlogCard from "@/components/blog/BlogCard";

interface AllBlogPostsProps {
  posts: {
    slug: string;
    frontMatter: {
      title?: string;
      description?: string;
    };
  }[];
}

export default function AllBlogPosts({ posts }: AllBlogPostsProps) {
  return (
    <section className="max-w-3xl mx-auto w-full flex flex-col gap-y-8">
      <div className="flex flex-col gap-y-2">
        <h1 className="text-lg font-semibold text-zinc-900 dark:text-zinc-100">
          Blog
        </h1>
        <p className="text-sm text-zinc-500 dark:text-zinc-400">
          Thoughts on web performance and engineering
        </p>
      </div>

      <div className="flex flex-col gap-y-6">
        {posts.map((post) => (
          <BlogCard key={post.slug} slug={post.slug} frontMatter={post.frontMatter} />
        ))}
      </div>
    </section>
  );
}
